package com.patronat.top.client.data.reviews

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.CreateReviewRequest
import com.patronat.top.dto.ReviewListResponse
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.dto.ReviewSummaryResponse
import io.ktor.client.HttpClient
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody

class ClientReviewsRemoteDataSource(
    private val httpClient: HttpClient
) {
    suspend fun getVenueReviews(
        venueId: String,
        page: Int,
        pageSize: Int
    ): NetworkResult<ReviewListResponse> {
        return safeApiCall {
            httpClient.get("venues/$venueId/reviews") {
                parameter("page", page)
                parameter("pageSize", pageSize)
            }
        }
    }

    suspend fun getVenueReviewSummary(venueId: String): NetworkResult<ReviewSummaryResponse> {
        return safeApiCall {
            httpClient.get("venues/$venueId/reviews/summary")
        }
    }

    suspend fun getMyReviews(
        page: Int,
        pageSize: Int
    ): NetworkResult<ReviewListResponse> {
        return safeApiCall {
            httpClient.get("reviews/me") {
                parameter("page", page)
                parameter("pageSize", pageSize)
            }
        }
    }

    suspend fun createReview(
        venueId: String,
        request: CreateReviewRequest
    ): NetworkResult<ReviewResponse> {
        return safeApiCall {
            httpClient.post("venues/$venueId/reviews") {
                setBody(request)
            }
        }
    }

    suspend fun likeReview(reviewId: String): NetworkResult<ReviewResponse> {
        return safeApiCall {
            httpClient.post("reviews/$reviewId/like")
        }
    }

    suspend fun unlikeReview(reviewId: String): NetworkResult<ReviewResponse> {
        return safeApiCall {
            httpClient.delete("reviews/$reviewId/like")
        }
    }
}
